import React from 'react';
import { Route, Routes } from 'react-router-dom';
import TariffList from './TariffList';

const TariffsPage = () => (
  <Routes>
    <Route path='list/:type' element={<TariffList />} />
  </Routes>
);

export default TariffsPage;
